import { ChangeDetectionStrategy, Component } from '@angular/core'
import { StaffFacade, StaffReportTypeEnum } from '@galabid/gb-dashboard/staff/data-access'
import * as StaffActions from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.actions'

@Component({
  selector: 'gb-staff-reports',
  templateUrl: './gb-staff-reports.component.html',
  styleUrls: ['./gb-staff-reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbStaffReportsComponent {
  staffReportCardItems = [
    {
      name: 'STAFF.CARD.VOUCHERS',
      description: 'STAFF.CARD.VOUCHERS_DESC',
      type: StaffReportTypeEnum.Vouchers,
    },
    {
      name: 'STAFF.CARD.APPLICATION_FEE',
      description: 'STAFF.CARD.APPLICATION_FEE_DESC',
      type: StaffReportTypeEnum.ApplicationFee,
    },
    {
      name: 'STAFF.CARD.IOC_PROFIT',
      description: 'STAFF.CARD.IOC_PROFIT_DESC',
      type: StaffReportTypeEnum.IocProfit,
    },
    {
      name: 'STAFF.CARD.AUCTION_CREATED',
      description: 'STAFF.CARD.AUCTION_CREATED_DESC',
      type: StaffReportTypeEnum.AuctionCreated,
    },
    {
      name: 'STAFF.CARD.GOOGLE_CAMPAIGN',
      description: 'STAFF.CARD.GOOGLE_CAMPAIGN_DESC',
      type: StaffReportTypeEnum.GoogleCampaign,
    },
    {
      name: 'STAFF.CARD.CLOSED_CAMPAIGNS',
      description: 'STAFF.CARD.CLOSED_CAMPAIGNS_DESC',
      type: StaffReportTypeEnum.CampaignsClosed,
    },
    {
      name: 'STAFF.CARD.IOC_ITEMS',
      description: 'STAFF.CARD.IOC_ITEMS_DESC',
      type: StaffReportTypeEnum.IocItems,
    },
    {
      name: 'STAFF.CARD.TICKETING_REVENUE',
      description: 'STAFF.CARD.TICKETING_REVENUE_DESC',
      type: StaffReportTypeEnum.TicketingRevenue,
    },
    {
      name: 'STAFF.CARD.DONATION_SLIDER_REVENUE',
      description: 'STAFF.CARD.DONATION_SLIDER_REVENUE_DESC',
      type: StaffReportTypeEnum.DonationSliderRevenue,
    },
  ]

  constructor(private staffFacade: StaffFacade) {}

  openDownloadReportDialog(staffReportType: StaffReportTypeEnum, dialogTitle: string) {
    // TODO: For IOC report, add auction search component in the dialog
    if (staffReportType === StaffReportTypeEnum.IocProfit) return

    this.staffFacade.dispatch(StaffActions.openDownloadReportDialog({ staffReportType, dialogTitle }))
  }
}
